import { render, staticRenderFns } from "./QuotePreview.vue?vue&type=template&id=19fb87a7&"
import script from "./QuotePreview.vue?vue&type=script&lang=js&"
export * from "./QuotePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports